export const NAME = 'experimentation'

const c = (x) => `${NAME}/${x}`

export const FEATURES = c('FEATURES')
export const FEATURES_LOADING = c('FEATURES_LOADING')
